import { Fragment } from "react/jsx-runtime";

interface ProgressProps {
  filled: number;
  total: number;
  filledColor?: string;
  labels?: string[];
}

const Progress: React.FC<ProgressProps> = ({
  filled,
  total,
  filledColor,
  labels,
}) => {
  const steps = Array.from({ length: total });

  const filledClass = filledColor ?? "bg-link";

  return (
    <div className={`flex-1 flex items-center justify-between ${labels && "pt-5"}`}>
      {steps.map((_, index) => {
        const isFilled = index < filled;

        return (
          <Fragment key={index}>
            <div className="relative flex items-center justify-center">
              {labels?.[index] && (
                <p className="absolute bottom-full text-[0.9375rem] leading-[1.25rem] text-subtitle-text">
                  {labels[index]}
                </p>
              )}
              <div
                className={`relative z-10 shrink-0 w-3.5 h-3.5 rounded-full ${
                  isFilled ? filledClass : "bg-quaternary-bg"
                } `}
              />
            </div>
            {index < total - 1 && (
              <div
                className={`flex-1 h-[0.1875rem] -mx-px ${
                  index < filled - 1 ? filledClass : "bg-quaternary-bg"
                }`}
              />
            )}
          </Fragment>
        );
      })}
    </div>
  );
};

export default Progress;
